import { makeStyles } from '@material-ui/core/styles'

export const styles = makeStyles((theme) => ({
  smallIcon: {
    marginRight: '5px',
    width: '40px',
  },
  clickable: {
    textAlign: 'left',
    '&:nth-child(even)': {
      background: theme.palette.components.linkListBackground,
      color: theme.palette.components.linkList,
    },
    borderRadius: 0,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.palette.button.hoverLight,
    },
    '&:hover:nth-child(even)': {
      backgroundColor: theme.palette.components.linkListBackgroundInverse,
      color: theme.palette.components.linkListDarkHover,
    },
    '&:focus-visible': {
      outline: `1px solid ${theme.palette.button.focusBorder}`,
      boxShadow: `0 0 0 3px ${theme.palette.button.focusOutline}`,
    },
  },
  iconLabel: {
    whiteSpace: 'pre-line',
  },
  buttonText: {
    textAlign: 'left',
  },
}))

export default styles
